import EditUser from './EditUser';

export default EditUser;